import React, { useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Pagination from '@mui/material/Pagination';
import Typography from '@mui/material/Typography';
import { Box, MenuItem, Radio, Select, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import Skeleton from '@mui/material/Skeleton';
import PropTypes from 'prop-types';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';
// import { RadioOff, RadioOn } from "@/svg";
import { Fragment } from 'react';

const StyledGridOverlay = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  '& .ant-empty-img-1': {
    fill: theme.palette.mode === 'light' ? '#aeb8c2' : '#262626'
  },
  '& .ant-empty-img-2': {
    fill: theme.palette.mode === 'light' ? '#f5f5f7' : '#595959'
  },
  '& .ant-empty-img-3': {
    fill: theme.palette.mode === 'light' ? '#dce0e6' : '#434343'
  },
  '& .ant-empty-img-4': {
    fill: theme.palette.mode === 'light' ? '#fff' : '#1c1c1c'
  },
  '& .ant-empty-img-5': {
    fillOpacity: theme.palette.mode === 'light' ? '0.8' : '0.08',
    fill: theme.palette.mode === 'light' ? '#f5f5f5' : '#fff'
  }
}));
const CheckedRadio = ({ checked, onChange }) => {
  return (
    <Radio
      checked={checked}
      onChange={onChange}
      // icon={<RadioOff />}
      // checkedIcon={<RadioOn />}
    />
  );
};

function loadingData() {
  let skeletonData = [];
  for (var i = 0; i < 9; i++) {
    skeletonData.push(<Skeleton height={50} key={i} />);
  }
  return (
    <Box
      fullWidth
      sx={{
        margin: '5px 10px'
      }}>
      {skeletonData}
    </Box>
  );
}

const CustomNoRowsOverlay = ({ nullMsg }) => {
  return (
    <StyledGridOverlay>
      <Box
        className='empty-data'
        sx={{
          mt: 1,
          fontSize: '14px',
          fontWeight: '400',
          lineHeight: '17.29px',
          textAlign: 'left'
        }}>
        <InboxOutlinedIcon fontSize='large' />
        <p>{nullMsg ? nullMsg : 'Tidak ada data'}</p>
      </Box>
    </StyledGridOverlay>
  );
};

export default function DatagridSiberat({
  rows,
  columns,
  getRowHeight,
  pagination,
  params,
  setParams,
  sortingMode,
  onSortModelChange,
  loading,
  customPagination,
  showPagination = false,
  autoHeight = true,
  overflowTable = false,
  checkboxSelection = false,
  filter_page = false,
  isRowSelectable = false,
  onRowSelectionModelChange,
  rowSelectionModel,
  columnVisibilityModel,
  marginTable,
  sx,
  keepNonExistentRowsSelected = false,
  heightTable,
  className,
  nullMsg,
  checkboxRadio = false,
  disableMultipleRowSelection = false,
  search,
  setMount,
  ...props
}) {
  const [pageNumber, setPageNumber] = useState(1);
  const pagesVisited = pageNumber * params?.per_page - params?.per_page;
  const handleChange = (event, value) => {
    setParams({
      ...params,
      ['page']: value
    });
    if (setMount) {
      setMount(true);
    }
  };

  const filterPage = [5, 10, 25, 50, 100];
  const rowDatagrid =
    sortingMode === 'client'
      ? rows
          .filter(row => {
            if (!search) {
              return row;
            } else if (
              Object.values(row)
                .join('')
                .toLowerCase()
                .includes(search?.toLowerCase())
            ) {
              return row;
            }
            return false;
          })
          .slice(pagesVisited, pagesVisited + params?.per_page)
      : rows;

  let pageCount;
  if (sortingMode === 'client') {
    pageCount = Math.ceil(
      rows.filter(row => {
        if (!search) {
          return row;
        } else if (
          Object.values(row)
            .join('')
            .toLowerCase()
            .includes(search?.toLowerCase())
        ) {
          return row;
        }
        return false;
      }).length / params?.per_page
    );
  }

  const showPaginate =
    rowDatagrid?.length == 0 ? false : !showPagination ? false : true;

  return (
    <div className='datagrid'>
      <DataGrid
        {...props}
        rows={loading ? [] : rowDatagrid}
        columns={columns}
        className={className}
        sortingOrder={['asc', 'desc']}
        checkboxSelection={checkboxSelection}
        isRowSelectable={isRowSelectable}
        disableRowSelectionOnClick
        disableColumnMenu
        getRowHeight={getRowHeight}
        sx={{
          ...sx,
          maxHeight: overflowTable ? heightTable ?? '315px' : '',
          '& .bold': {
            fontWeight: 'bold'
          }
        }}
        getRowClassName={params => [
          params.row.hideCheckbox ? 'hide-checkbox' : '',
          params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd-row'
        ]}
        hideFooter={true}
        sortingMode={sortingMode}
        loading={loading}
        onSortModelChange={onSortModelChange}
        slots={{
          noRowsOverlay: () => <CustomNoRowsOverlay nullMsg={nullMsg} />,
          loadingOverlay: loadingData,
          baseCheckbox: props => <CheckedRadio {...props} />
        }}
        style={{
          borderRadius: showPaginate ? '8px 8px 0 0' : '8px',
          borderBottom: !showPaginate ? '1px solid #E5E7EB' : ''
        }}
        onRowSelectionModelChange={onRowSelectionModelChange}
        rowSelectionModel={rowSelectionModel}
        columnVisibilityModel={columnVisibilityModel}
        keepNonExistentRowsSelected={keepNonExistentRowsSelected}
        disableMultipleRowSelection={disableMultipleRowSelection}
      />
      {showPaginate && (
        <Fragment>
          {customPagination ? (
            <Box className='total'>{customPagination}</Box>
          ) : (
            <div className='pagination-area'>
              {sortingMode === 'client' ? (
                <Box className='pagination-datagrid'>
                  <Typography>
                    Showing <strong>{rowDatagrid?.length}</strong> dari{' '}
                    <strong> {params?.per_page} </strong>entri
                  </Typography>
                  <Stack
                    direction='row'
                    spacing={2}
                    sx={{
                      alignItems: 'center'
                    }}>
                    {filter_page && (
                      <Stack
                        direction='row'
                        spacing={2}
                        sx={{
                          alignItems: 'center'
                        }}>
                        <p>Rows per page:</p>
                        <Select
                          className='row-perpage'
                          labelId='demo-simple-select-standard-label'
                          id='demo-simple-select-standard'
                          value={params?.per_page || ''}
                          // value={params?.per_page > 50 ? "All" : params?.per_page}
                          placeholder='a'
                          onChange={e => {
                            setPageNumber(1);
                            setParams({
                              ...params,
                              page: 1,
                              per_page: e?.target?.value
                              // per_page:
                              //   e?.target?.value === "All"
                              //     ? pagination?.total
                              //     : e?.target?.value,
                            });
                            if (setMount) {
                              setMount(true);
                            }
                          }}
                          label='Age'
                          size='small'
                          sx={{
                            border: 'none'
                          }}>
                          {filterPage?.map((row, index) => (
                            <MenuItem value={row} key={index}>
                              {row}
                            </MenuItem>
                          ))}
                        </Select>
                      </Stack>
                    )}

                    <Pagination
                      count={pageCount}
                      page={params?.page}
                      onChange={(event, value) => {
                        setParams({
                          ...params,
                          page: value
                        });
                        if (setMount) {
                          setMount(true);
                        }
                        setPageNumber(value);
                      }}
                    />
                  </Stack>
                </Box>
              ) : (
                <Box className='pagination-datagrid'>
                  <Typography className='legend-pagination'>
                    Showing <strong>{pagination?.data?.length}</strong> to{' '}
                    <strong> {pagination?.total} </strong>entri
                  </Typography>
                  {/* {filter_page && ( */}
                  <Stack
                    direction='row'
                    spacing={2}
                    sx={{
                      alignItems: 'center'
                    }}>
                    {filter_page && (
                      <>
                        <p>Rows per page:</p>
                        <Select
                          className='row-perpage'
                          labelId='demo-simple-select-standard-label'
                          id='demo-simple-select-standard'
                          value={params?.per_page || ''}
                          // value={params?.per_page > 50 ? "All" : params?.per_page}
                          placeholder='a'
                          onChange={e => {
                            setPageNumber(1);
                            setParams({
                              ...params,
                              page: 1,
                              per_page: e?.target?.value
                              // e?.target?.value === "All"
                              //   ? pagination?.total
                              //   : e?.target?.value,
                            });
                            if (setMount) {
                              setMount(true);
                            }
                          }}
                          label='Age'
                          size='small'
                          sx={{
                            border: 'none'
                          }}>
                          {filterPage?.map((row, index) => (
                            <MenuItem value={row} key={index}>
                              {row}
                            </MenuItem>
                          ))}
                        </Select>
                      </>
                    )}

                    <Pagination
                      count={pagination?.last_page}
                      page={params?.page}
                      onChange={handleChange}
                    />
                  </Stack>
                  {/* // )} */}
                </Box>
              )}
            </div>
          )}
        </Fragment>
      )}
    </div>
  );
}

DatagridSiberat.propTypes = {
  columns: PropTypes.array.isRequired,
  rows: PropTypes.array.isRequired,
  showPagination: PropTypes.bool,
  autoHeight: PropTypes.bool,
  checkboxSelection: PropTypes.bool
};

// DatagridSiberat.defaultProps = {
// 	showPagination: false,
// 	autoHeight: true,
// 	checkboxSelection: false,
// };
